/**
 * relativeTime — small, dependency-free "time ago" formatter.
 *
 * Sized to fit one line (just now / Nm / Nh / Nd ago), falling back to an
 * absolute short month-day past a week so older entries get a stable label
 * rather than a churning "13d ago" / "2w ago". Avoids pulling in `date-fns`
 * for these ~5 cases. Shared by the Feed rows and the advisor conversation
 * sidebar; returns "—" for missing/unparseable input.
 */
export function relativeTime(iso?: string | null): string {
  if (!iso) return "—";
  const then = new Date(iso).getTime();
  if (!Number.isFinite(then)) return "—";
  const diffMs = Date.now() - then;
  if (diffMs < 60_000) return "just now";
  const minutes = Math.floor(diffMs / 60_000);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 7) return `${days}d ago`;
  return new Date(iso).toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
  });
}
